import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';

interface UseBillingPaymentUncancel {
  paymentId?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const useBillingPaymentUncancel = ({ paymentId, onSuccess, onError }: UseBillingPaymentUncancel) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingPaymentUncancel', paymentId],
    mutationFn: () => privateAxios.put(`/billing/payments/${paymentId}/uncancel`),
    onSuccess,
    onError,
  });
};
